<!--Base Version 2.0.2-->
<template>
    <v-app>
        <app-nav-bar v-if="showNav" v-show="!inPrint"></app-nav-bar>
        <v-content style="max-height: 100vh" v-show="!inPrint">
            <login
                    @succesfullLogin="succesfullLogin($event)"
                    v-if="!showNav"
            />
            <dashboard v-else/>
            <doc-repo-downloads style="z-index: 999" />
        </v-content>
        <create-mail-print @print="inPrint = $event"/>
    </v-app>
</template>

<script>
    import { eventBus } from './main';
    import Navbar from './components/General/NavBar.vue'
    import { codeBaseMixin } from './codeBaseMixin';
    import Login from "./views/Login";
    import Dashboard from "./views/Dashboard";
    import DocRepoDownloads from "@/Document Repository/docRepoDownloads";
    import CreateMailPrint from "@/Mail/Create Mail/CreateMailPrint";
    import {mapActions, mapGetters} from "vuex";
    let tokenMan = require('./tokenManSite');

    export default {
        name: 'App',
        mixins: [codeBaseMixin],
        components: {
            CreateMailPrint,
            DocRepoDownloads,
            Dashboard,
            Login,
            appNavBar: Navbar
        },
        data() {
            return {
                testURL: `https://app.tasklogix.co.za/upload/download/3/356e762b1211ecc76af4bb7eb1bd1cfc/POLICY%20WORDING.pdf`,
                showNav: false,
                inPrint: false,
            }

        },
        created() {
            eventBus.$on('showHideNav', this.showHideNav);
            tokenMan.events.on('refreshToken', this.renewToken);




        },
        beforeDestroy() {
            eventBus.$off('showHideNav', this.showHideNav);
            tokenMan.events.off('refreshToken', this.renewToken)
        },
        methods: {

            showHideNav(value) {this.showNav = value;this.setLoggedIn(value)},

            ...mapActions(['setLoggedIn']),

            renewToken(retryCount = 0) {
                if (retryCount < 24) {
                    this.fetch({
                        method: 'PATCH',
                        url:`/login`,
                        body: JSON.stringify({
                            userKey: tokenMan.userKey(),
                            token: tokenMan.token()
                        })
                    })
                        .then((data) => {
                            tokenMan.renewToken(data);
                        })
                        .catch((e) => {
                            // eslint-disable-next-line
                            console.log(e)
                            this.showSnack('Error', `Token Renew Failed Attempt ${retryCount + 1}`, 'Close', 'red');
                            setTimeout(() => {
                                this.renewToken(++retryCount)
                            }, retryCount * 1000)
                        })
                } else {


                    this.showNav = false;
                }
            },
            succesfullLogin(loginInfo) {
                if (loginInfo.gmailTokenCode != '') {

                    const jBody = {
                        code: loginInfo.gmailTokenCode,
                        userKey: loginInfo.apiKey
                    };

                    this.fetch({method: 'POST', url:`/gmail/auth/newToken`, body: JSON.stringify(jBody)})
                        .then((data) => {
                            if (data.status == "Success") {
                                eventBus.$emit('gmailAuthorized');
                            }
                        })
                        .catch((e) => {
                            // eslint-disable-next-line
                            console.log(e)
                            this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red')
                        })
                }

                if (loginInfo.officeTokenCode != '') {
                    const jBody = {
                        code: loginInfo.officeTokenCode,
                        userKey: loginInfo.apiKey
                    };

                    this.fetch({method: 'GET', url:`/office/auth/newToken`, body: JSON.stringify(jBody)})
                        .then((data) => {
                            if (data.status == "Success") {
                                eventBus.$emit('officeAuthorized');
                            }
                        })
                        .catch((e) => {
                            // eslint-disable-next-line
                            console.log(e)
                            this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red')
                        })
                }
            }
        },
        computed: {
        }
    }
</script>

<style>



</style>
